import { css as a } from "styled-components";
import { m as e } from "./style-ImpGK6sv.js";
const i = {
  xs: "12px",
  md: "16px",
  xl: "48px",
  xxl: "88px"
}, n = {
  md: "736px",
  xl: "1128px",
  xxl: "1648px"
}, o = () => Object.keys(i).map(
  (t) => a`
      @media ${e(t)} {
        padding-right: ${i[t]};
        padding-left: ${i[t]};
      }
    `
), s = () => Object.keys(n).map(
  (t) => a`
      @media ${e(t)} {
        max-width: ${n[t]};
      }
    `
), p = a`
  position: relative;
  margin-right: auto;
  margin-left: auto;
  width: 100%;

  ${o()}
  ${({ $fluid: t }) => !t && s()}
`;
export {
  p as c
};
